if (!customElements.get('video-with-text-banner')) {
  class VideoWithText extends HTMLElement {
    constructor() {
      super();
      this.selector = {
        video: 'video',
        img: 'img'
      };
      this.init();
    }

    init() {
      this.video = this.querySelector(this.selector.video);
      this.image = this.querySelector(this.selector.img);
      if (this.video) {
        // Initialize Intersection Observer
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach(entry => {
              if (entry.isIntersecting && entry.intersectionRatio >= 0.8) {
                this.playVideo();
              } else {
                this.pauseVideo(); // Optional: Pause video when not in view
              }
            });
          },
          {
            threshold: [0.8] // Trigger callback when 20% is visible
          }
        );

        // Observe the custom element itself
        this.observer.observe(this);

        // Optional: Load video when component loads
        window.addEventListener('load', () => {
          this.video.load();
          this.video.addEventListener('canplaythrough', () => {
            console.log("Video can play through");
          });
        });
      }
    }

    playVideo() {
      if (this.video) {
        this.video.play();
        this.video.classList.remove('hidden');
        if (this.image) {
          this.image.classList.add('hidden');
        }
        console.log("PLAY VIDEO");
      }
    }

    pauseVideo() {
      if (this.video) {
        this.video.pause();
        console.log("PAUSE VIDEO");
      }
    }

    disconnectedCallback() {
      // Clean up observer when the element is removed from the DOM
      if (this.observer) {
        this.observer.unobserve(this);
      }
    }
  }

  customElements.define('video-with-text-banner', VideoWithText);
}
